function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 125,
  r: 100,
  fill: "url(#paint0_radial)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "border",
  cx: 125,
  cy: 125,
  r: 105,
  stroke: "white",
  strokeWidth: 10
})), /*#__PURE__*/React.createElement("circle", {
  cx: 71.5,
  cy: 115.5,
  r: 10.5,
  fill: "#4F4D48"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177.5,
  cy: 115.5,
  r: 10.5,
  fill: "#4F4D48"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.813 151.5C102.707 151.5 100.95 149.752 101.614 147.753C101.904 146.879 102.297 146.02 102.789 145.186C103.97 143.184 105.701 141.365 107.883 139.833C110.065 138.301 112.656 137.085 115.507 136.256C118.358 135.427 121.414 135 124.5 135C127.586 135 130.642 135.427 133.493 136.256C136.344 137.085 138.935 138.301 141.117 139.833C143.299 141.365 145.03 143.184 146.211 145.186C146.703 146.02 147.096 146.879 147.386 147.753C148.05 149.752 146.293 151.5 144.187 151.5V151.5C142.081 151.5 140.425 149.712 139.487 147.827C139.388 147.628 139.281 147.43 139.166 147.235C138.368 145.882 137.199 144.654 135.725 143.619C134.251 142.584 132.501 141.763 130.575 141.203C128.649 140.643 126.585 140.354 124.5 140.354C122.415 140.354 120.351 140.643 118.425 141.203C116.499 141.763 114.749 142.584 113.275 143.619C111.801 144.654 110.632 145.882 109.834 147.235C109.719 147.43 109.612 147.628 109.513 147.827C108.575 149.712 106.919 151.5 104.813 151.5V151.5Z",
  fill: "#4F4D48"
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 30.79,
  rx: 3,
  transform: "matrix(-0.435105 0.90038 0.90038 0.435105 67.6106 81)",
  fill: "#4F4D48"
}), /*#__PURE__*/React.createElement("rect", {
  x: 183.254,
  y: 81,
  width: 6,
  height: 30.79,
  rx: 3,
  transform: "rotate(64.208 183.254 81)",
  fill: "#4F4D48"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: -3,
  y: 0,
  width: 256,
  height: 256,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 12,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.992157 0 0 0 0 0.796078 0 0 0 0 0.356863 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-14 68) rotate(21.3916) scale(220.705)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.42
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.230076,
  stopColor: "#FFE927"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642194,
  stopColor: "#FFE43B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.989483,
  stopColor: "#FFD66D"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 250,
  height: 250,
  fill: "white"
})));

var SvgVerysadFace1 = function SvgVerysadFace1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVerysadFace1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Very sadFace 1.59840569.svg";
export { ForwardRef as ReactComponent };